import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';
import { getFormattedPrice } from '../../helpers/CurrencyUtils';

export default function CashoutHistoryTotal({ count, totalAmount }) {
  const { t } = useTranslation(null, { useSuspense: false });

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        categories: {
          cashout: cashoutCurrency,
        },
      } = {},
    } = {},
  } = config || {};

  const currency = cashoutCurrency.toUpperCase();

  return (
    <div>
      <div>
        <h4>
          {t('history-total_total_transactions')}
        </h4>
        <p>
          { count }
        </p>
      </div>

      <div>
        <h4>
          {t('history-total_total_cash_out_amount')}
        </h4>
        <p>
          { getFormattedPrice(totalAmount, currency) }
        </p>
      </div>
    </div>
  );
}
CashoutHistoryTotal.propTypes = {
  count: PropTypes.number.isRequired,
  totalAmount: PropTypes.number.isRequired,
};
